(() => {
  'use strict';
  const publish = (event, data = {}) => {
    if (window.Shopify?.designMode || window.Shopify?.theme?.role !== 'main') return;
    if (!window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()) return;
    try {
      if (!window.Shopify.analytics?.publish) return false;
      window.Shopify.analytics.publish(`fairy_petal:${event}`, data); return true;
    } catch (_) { return false; }
  };
  function initDiscovery(root) {
    if (root.dataset.ready) return;
    let products;
    try { products = JSON.parse(root.querySelector('[data-fp-products]').textContent); } catch (_) { return; }
    if (!Array.isArray(products) || !products.length) return;
    const form = root.querySelector('form');
    const results = root.querySelector('[data-fp-results]');
    const status = root.querySelector('.fp-result-count');
    const more = root.querySelector('.fp-more');
    const fields = ['color', 'occasion', 'kind', 'stock', 'min', 'max', 'sort', 'pick'];
    const facets = {color: 'colors', occasion: 'occasions', kind: 'kind'};
    const currency = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style: 'currency', currency: root.dataset.currency || 'USD'});
    let shown = 24;
    const values = () => Object.fromEntries(fields.map(k => [k, (form.elements.namedItem(k).type === 'checkbox' ? (form.elements.namedItem(k).checked ? '1' : '') : form.elements.namedItem(k).value)]));
    function matches(p, filters, except = '') {
      return Object.keys(facets).every(k => k === except || !filters[k] || [].concat(p.metadata[facets[k]] || []).includes(filters[k]))
        && (!filters.pick || p.metadata.pick)
        && (!filters.stock || (filters.stock === 'available' ? p.available : !p.available))
        && (filters.min === '' || p.priceMax >= Math.round(Number(filters.min) * 100))
        && (filters.max === '' || p.price <= Math.round(Number(filters.max) * 100));
    }
    const initial = new URLSearchParams(location.search);
    for (const key of Object.keys(facets)) {
      const options = [...new Set(products.flatMap(p => [].concat(p.metadata[facets[key]] || [])))].sort();
      const select = form.elements.namedItem(key);
      options.forEach(value => select.add(new Option(value, value)));
    }
    const readURL = () => {
      const params = new URLSearchParams(location.search);
      fields.forEach(k => {
        const el = form.elements.namedItem(k);
        const value = params.get(`fp_${k}`) || (k === 'sort' ? 'featured' : '');
        if (el.type === 'checkbox') el.checked = value === '1'; else el.value = value;
        if (el.tagName === 'SELECT' && el.selectedIndex < 0) el.selectedIndex = 0;
      });
    };
    readURL();
    function card(p) {
      const article = document.createElement('article'); article.className = 'fp-card';
      const link = document.createElement('a'); link.href = p.url; link.dataset.fpRoute = 'filtered-gifts';
      if (p.image) {
        const img = document.createElement('img'); img.src = p.image; img.alt = p.title;
        img.width = 600; img.height = 750; img.loading = 'lazy'; img.decoding = 'async';
        link.append(img);
      }
      const title = document.createElement('h3'); title.textContent = p.title; link.append(title);
      const price = document.createElement('p'); price.textContent = `${p.varies ? 'From ' : ''}${currency.format(p.price / 100)}${p.available ? '' : ' · Sold out'}`;
      article.append(link, price); return article;
    }
    function render(updateURL = false) {
      const filters = values();
      let filtered = products.filter(p => matches(p, filters));
      const sorters = {
        featured: (a,b) => Number(b.metadata.pick) - Number(a.metadata.pick),
        'price-low': (a,b) => a.price - b.price,
        'price-high': (a,b) => b.price - a.price,
        title: (a,b) => a.title.localeCompare(b.title),
        newest: (a,b) => Number(b.created) - Number(a.created)
      };
      filtered.sort(sorters[filters.sort] || sorters.featured);
      Object.keys(facets).forEach(key => {
        const select = form.elements.namedItem(key);
        [...select.options].forEach(option => {
          if (!option.value) return;
          const count = products.filter(p => matches(p, {...filters, [key]: option.value})).length;
          option.hidden = count === 0 && !option.selected;
          option.disabled = count === 0 && !option.selected;
          option.textContent = `${option.value} (${count})`;
        });
      });
      const stock = form.elements.namedItem('stock');
      [...stock.options].forEach(o => {
        if (!o.value) return;
        const count = products.filter(p => matches(p, {...filters, stock: o.value})).length;
        o.hidden = !count && !o.selected; o.disabled = !count && !o.selected;
      });
      const fragment = document.createDocumentFragment();
      filtered.slice(0, shown).forEach(p => fragment.append(card(p)));
      results.replaceChildren(fragment);
      status.textContent = filtered.length ? `${filtered.length} gifts · Showing ${Math.min(shown, filtered.length)}` : 'No gifts match these choices. Clear a filter or try another color story.';
      more.hidden = filtered.length <= shown;
      if (updateURL) {
        const url = new URL(location.href);
        fields.forEach(k => filters[k] && !(k === 'sort' && filters[k] === 'featured') ? url.searchParams.set(`fp_${k}`, filters[k]) : url.searchParams.delete(`fp_${k}`));
        url.searchParams.delete('page');
        history.pushState(null, '', url);
        publish('gift_filter_applied', {result_count: filtered.length, color: filters.color, occasion: filters.occasion, gift_type: filters.kind});
      }
    }
    form.addEventListener('submit', e => { e.preventDefault(); if (!form.reportValidity()) return; shown = 24; render(true); });
    form.addEventListener('change', () => { if (form.checkValidity()) { shown = 24; render(true); } });
    form.addEventListener('reset', () => { setTimeout(() => { shown = 24; render(true); }, 0); });
    more.addEventListener('click', () => { shown += 24; render(); });
    window.addEventListener('popstate', () => { readURL(); shown = 24; render(); });
    render();
    root.dataset.ready = 'true'; root.hidden = false;
    document.querySelectorAll('collection-component').forEach(el => { el.closest('.shopify-section')?.classList.add('fp-native-fallback'); });
  }
  function init(scope = document) {
    scope.querySelectorAll('[data-fp-discovery]').forEach(initDiscovery);
  }
  init();
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('click', e => {
    const link = e.target.closest('a[data-fp-route]');
    if (link) publish('shopping_path_selected', {path: link.dataset.fpRoute});
  });
  const inquiry = document.getElementById('FairyCustomRequest');
  if (inquiry) {
    inquiry.addEventListener('submit', () => {
      if (inquiry.checkValidity() && publish('custom_inquiry_submitted')) {
        try { sessionStorage.setItem('fp-inquiry-pending', String(Date.now())); } catch (_) {}
      }
    });
    if (inquiry.querySelector('.fp-form-success')) {
      try {
        const pending = Number(sessionStorage.getItem('fp-inquiry-pending'));
        sessionStorage.removeItem('fp-inquiry-pending');
        if (pending && Date.now() - pending < 900000) publish('custom_inquiry_success');
      } catch (_) {}
    }
  }
  // Keep both mobile navigation and the purchase button usable; accommodate the keyboard.
  const dock = document.querySelector('.fairy-mobile-dock');
  if (dock && 'ResizeObserver' in window) {
    const dockSize = new ResizeObserver(() => document.documentElement.style.setProperty('--fp-mobile-dock-height', `${dock.getBoundingClientRect().height}px`));
    dockSize.observe(dock);
  }
  const viewport = window.visualViewport;
  if (viewport) {
    const updateKeyboard = () => document.body.classList.toggle('fp-keyboard-open', window.innerHeight - viewport.height > 150 && /INPUT|TEXTAREA|SELECT/.test(document.activeElement?.tagName));
    viewport.addEventListener('resize', updateKeyboard);
    document.addEventListener('focusout', () => setTimeout(updateKeyboard, 100));
  }
})();
